<template>
    <div>
        <!-- 吸顶导航 -->
        <van-sticky>
            <van-nav-bar style="background-color: #3f78f6; margin-bottom: 0rem; border: 0" title="" left-text=""
                left-arrow @click-left="onClickLeft">
                <template #title>
                    <span style="color: white;font-size: .4rem;">请假管理</span>
                </template>
                <template #left>
                    <van-icon name="arrow-left" color="white" size="18" />
                </template>
            </van-nav-bar>
        </van-sticky>
        <!-- 中间内容展示 -->
        <section class="van-doc-demo-section">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                <div class="locusItems" v-for="item in list" :key="item.id">
                    <table border="0" style="font-size:.4rem;margin:0 .5rem">
                        <tr>
                            <td style='text-align:right;color:#666666'>发起时间：</td>
                            <td colspan="2">{{ item.ftime }}</td>
                        </tr>
                        <tr>
                            <td style='text-align:right;color:#666666'>请假人：</td>
                            <td>{{item.fname }}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td style='text-align:right;color:#666666'>类型：</td>
                            <td>{{item.fnum }}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td style='text-align:right;color:#666666'>开始时间：</td>
                            <td colspan="2">{{ item.starts_time}}</td>
                        </tr>
                        <tr>
                            <td style='text-align:right;color:#666666'>结束时间：</td>
                            <td colspan="2">{{ item.ends_time }}</td>
                        </tr>
                        <tr>
                            <td style='text-align:right;color:#666666'>请假事由：</td>
                            <td colspan="2">{{ item.remarks }}</td>
                        </tr>
                        <tr>
                            <td style='text-align:right;color:#666666'>是否离校：</td>
                            <td>{{ item.is_lea_school==1 ? '不离校':'离校'}}</td>
                            <td>
                                <van-tag round :type="item.fstate" :key="item.id" style="font-size: .4rem;
              width: 2rem;
              height: .6rem;
              text-align: center;
              padding-top: .2rem;
              display: block;
              color: white;
              background-color: #3f78f6;
              position: absolute;
              top: 4rem;
              right: 01rem;
              left:7.2rem;
              border-radius: 0.585185rem;
            " @click="close(item.id,item.fstatus,item.tag)">{{ item.fstatus }}</van-tag>
                            </td>
                        </tr>
                    </table>
                </div>
            </van-list>
        </section>
        <!-- 底部tabbar -->
        <van-tabbar v-model="active" active-color="#0092ff" inactive-color="#7f7f7f">
            <van-tabbar-item to="StudentLeave">
                <span>请假记录</span>
                <template #icon="props">
                    <img :src="props.active ? icon1.active : icon1.inactive" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item v-show="qj" to="StudentLeaveAdd">
                <span >请假登记</span>
                <template #icon="props">
                    <img :src="props.active ? icon2.active : icon2.inactive" />
                </template>
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                active: 0,
                value: "",
                shenfen: "",
                tname: "",
                tcode: "",
                loading: false,
                finished: false,
                student: "",
                qj:true,
                page: "",
                list: [],
                icon1: {
                    active: require('@/image/tab1.png'),
                    inactive: require('@/image/tab10.png'),
                },
                icon2: {
                    active: require('@/image/tab2.png'),
                    inactive: require('@/image/tab20.png'),
                },
            };
        },
        created() {
            this.student = this.$route.query.student;
            this.page = this.$route.query.page;
            console.log("传递过来得学生ID：" + this.student + "和默认轮播定位：" + this.page);
            this.init();
        },
        methods: {
            init() {
                var json = window.localStorage.getItem("User");
                var jsonObj = JSON.parse(json);
                console.log("身份:" + jsonObj[0]["shenfen"]);
                var code;
                this.tname = jsonObj[0]["username"];
                this.shenfen = jsonObj[0]["shenfen"];
                if (jsonObj[0]["shenfen"] == "老师") {
                    code = jsonObj[0]["number"];
                    this.tcode = code;
                    this.qj = true;
                } else if (jsonObj[0]["shenfen"] == "学生") {
                    code = jsonObj[0]["number"];
                    this.qj = false;
                } else {
                    this.qj = false;
                    // code = jsonObj[0]["phone"];
                    code =  this.student;
                }
                var params_json = {
                    userid: code,
                    action: "QJList",
                    param1: jsonObj[0]["shenfen"],
                    param2: "",
                    param3: "",
                    param4: "",
                    param5: ""
                };

                this.$http
                    .post("/web/list", params_json)
                    .then(function (res) {
                        console.log(res.data["rows"]);
                        this.list = res.data["rows"];
                    });
                this.onLoad();
            },
            onClickLeft() {
                // this.$router.push("Index");
                this.$router.push({
                    path: "Index",
                    query: {
                        page: this.page
                    }
                });
            },
            onLoad() {
                // 异步更新数据
                // setTimeout 仅做示例，真实场景中一般为 ajax 请求
                setTimeout(() => {
                    // 加载状态结束
                    this.loading = false;

                    // 数据全部加载完成
                    if (this.list.length >= this.list.length) {
                        this.finished = true;
                    }
                }, 1000);
            },
            close(id, status,tag) {
                if (this.shenfen == "老师" && status == "待审批"  && tag ==1 ) {
                    console.log("进入if");
                    this.$dialog.confirm({
                            title: '审批',
                            message: "是否审批该请假单!",
                            confirmButtonText: "通过",
                            cancelButtonText: "不通过",
                            // closeOnClickOverlay:true
                        })
                        .then(() => {
                            var params_json = {
                                userid: this.tcode,
                                action: "QJApprove",
                                param1: id,
                                param2: "1",
                                param3: this.tname,
                                param4: "",
                                param5: ""
                            };
                            this.$http
                                .post("/web/save", params_json)
                                .then(function (res) {
                                    let obj = res.data;
                                    console.log("注册后返回消息:" + obj.msg);
                                    if (obj.msg == "0") {
                                        this.$notify({
                                            type: "success",
                                            message: "审批通过!"
                                        });
                                        this.init();
                                    }
                                });
                        })
                        .catch(() => {
                            var params_json = {
                                userid: this.tcode,
                                action: "QJApprove",
                                param1: id,
                                param2: "2",
                                param3: this.tname,
                                param4: "",
                                param5: ""
                            };
                            this.$http
                                .post("/web/save", params_json)
                                .then(function (res) {
                                    let obj = res.data;
                                    console.log("注册后返回消息:" + obj.msg);
                                    if (obj.msg == "0") {
                                        this.$notify({
                                            type: "success",
                                            message: "审批不通过!"
                                        });
                                    }
                                    this.init();
                                });
                        });
                } else {
                    console.log("进入return");
                    return;
                }
            },
        },
    };
</script>

<style>
    .van-doc-demo-section {
        box-sizing: border-box;
        min-height: calc(100vh - 1.49333rem);
        padding-bottom: 1.53333rem;
    }
</style>